import {PaymentMethodTypesEnum} from 'src/products/general/GeneralPaymentMethods/types'

export const getPaymentMethodEventTypeFromEnum = (type: PaymentMethodTypesEnum): string => {
  switch (type) {
    case PaymentMethodTypesEnum.DebitCard:
      return 'add_debit_card'
    case PaymentMethodTypesEnum.AccountRouting:
      return 'add_routing_account'
    case PaymentMethodTypesEnum.Plaid:
      return 'add_link_with_plaid'
    default:
      return ''
  }
}
